import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withDirectives as _withDirectives, toDisplayString as _toDisplayString, withCtx as _withCtx, createSlots as _createSlots } from "vue"

const _hoisted_1 = {
  key: 0,
  ref: "filter",
  class: "p-listbox-header"
}
const _hoisted_2 = { class: "p-listbox-filter-container" }
const _hoisted_3 = /*#__PURE__*/_createVNode("span", { class: "p-listbox-filter-icon pi pi-search" }, null, -1)
const _hoisted_4 = { class: "p-menuitem-text" }
const _hoisted_5 = { class: "kn-list-item-text" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = {
  key: 1,
  class: "kn-list-item-text-secondary kn-truncated"
}
const _hoisted_8 = /*#__PURE__*/_createVNode("i", { class: "fas fa-check" }, null, -1)
const _hoisted_9 = { class: "kn-list-item-text" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = {
  key: 1,
  class: "kn-list-item-text-secondary kn-truncated"
}
const _hoisted_12 = {
  key: 2,
  class: "kn-list-item-text-secondary kn-truncated"
}
const _hoisted_13 = /*#__PURE__*/_createVNode("i", { class: "fas fa-check" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")
  const _component_Menu = _resolveComponent("Menu")
  const _component_Avatar = _resolveComponent("Avatar")
  const _component_Badge = _resolveComponent("Badge")
  const _component_KnListButtonRenderer = _resolveComponent("KnListButtonRenderer")
  const _component_router_link = _resolveComponent("router-link")
  const _component_Listbox = _resolveComponent("Listbox")
  const _directive_tooltip = _resolveDirective("tooltip")

  return (_openBlock(), _createBlock(_component_Listbox, {
    class: ["kn-list knListBox", { noSorting: !_ctx.settings.sortFields }],
    options: _ctx.sortedOptions,
    listStyle: "max-height:calc(100% - 66px)",
    filter: !_ctx.settings.fullTextSearch,
    filterPlaceholder: _ctx.$t('common.search'),
    filterMatchMode: "contains",
    filterFields: _ctx.settings.filterFields,
    emptyFilterMessage: _ctx.$t('common.info.noDataFound'),
    "data-test": "list"
  }, _createSlots({
    option: _withCtx((slotProps) => [
      (_ctx.settings.interaction.type === 'router')
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 0,
            class: "kn-decoration-none",
            to: { name: _ctx.settings.interaction.path, params: { id: slotProps.option.id } },
            exact: ""
          }, {
            default: _withCtx(() => [
              _withDirectives(_createVNode("div", {
                class: ["kn-list-item", _ctx.getBorderClass(slotProps.option)],
                "data-test": "list-item"
              }, [
                (_ctx.settings.avatar && _ctx.settings.avatar.values[slotProps.option[_ctx.settings.avatar.property]])
                  ? (_openBlock(), _createBlock(_component_Avatar, {
                      key: 0,
                      icon: _ctx.settings.avatar.values[slotProps.option[_ctx.settings.avatar.property]].icon,
                      shape: "circle",
                      style: _ctx.settings.avatar.values[slotProps.option[_ctx.settings.avatar.property]].style
                    }, null, 8, ["icon", "style"]))
                  : _createCommentVNode("", true),
                _createVNode("div", _hoisted_5, [
                  (_ctx.settings.titleField !== false)
                    ? (_openBlock(), _createBlock("span", _hoisted_6, _toDisplayString(slotProps.option[_ctx.settings.titleField || "label"]), 1))
                    : _createCommentVNode("", true),
                  (_ctx.settings.textField !== false)
                    ? (_openBlock(), _createBlock("span", _hoisted_7, _toDisplayString(slotProps.option[_ctx.settings.textField || "name"]), 1))
                    : _createCommentVNode("", true)
                ]),
                (_ctx.settings.badgeField)
                  ? (_openBlock(), _createBlock(_component_Badge, {
                      key: 1,
                      value: slotProps.option[_ctx.settings.badgeField],
                      severity: _ctx.settings.badgeSeverity || 'info'
                    }, null, 8, ["value", "severity"]))
                  : _createCommentVNode("", true),
                (_ctx.settings.badgeIcon && slotProps.option[_ctx.settings.badgeIcon] === true)
                  ? (_openBlock(), _createBlock(_component_Badge, {
                      key: 2,
                      severity: _ctx.settings.badgeSeverity || 'info'
                    }, {
                      default: _withCtx(() => [
                        _hoisted_8
                      ]),
                      _: 1
                    }, 8, ["severity"]))
                  : _createCommentVNode("", true),
                _createVNode(_component_KnListButtonRenderer, {
                  buttons: _ctx.settings.buttons,
                  onClick: ($event: any) => (_ctx.clickedButton($event, slotProps.option))
                }, null, 8, ["buttons", "onClick"])
              ], 2), [
                [_directive_tooltip, slotProps.option[_ctx.settings.tooltipField || 'description']]
              ])
            ]),
            _: 2
          }, 1032, ["to"]))
        : _createCommentVNode("", true),
      (!_ctx.settings.interaction || _ctx.settings.interaction.type === 'event')
        ? _withDirectives((_openBlock(), _createBlock("div", {
            key: 1,
            class: ["kn-list-item", [{ 'router-link-active': _ctx.isItemSelected(slotProps.option) }, _ctx.getBorderClass(slotProps.option)]],
            onClick: ($event: any) => (_ctx.clickedButton($event, slotProps.option)),
            "data-test": "list-item"
          }, [
            (_ctx.settings.avatar && _ctx.settings.avatar.values[slotProps.option[_ctx.settings.avatar.property]])
              ? (_openBlock(), _createBlock(_component_Avatar, {
                  key: 0,
                  icon: _ctx.settings.avatar.values[slotProps.option[_ctx.settings.avatar.property]].icon,
                  shape: "circle",
                  style: _ctx.settings.avatar.values[slotProps.option[_ctx.settings.avatar.property]].style
                }, null, 8, ["icon", "style"]))
              : _createCommentVNode("", true),
            _createVNode("div", _hoisted_9, [
              (_ctx.settings.titleField !== false)
                ? (_openBlock(), _createBlock("span", _hoisted_10, _toDisplayString(slotProps.option[_ctx.settings.titleField || "label"]), 1))
                : _createCommentVNode("", true),
              (_ctx.settings.textField !== false && !_ctx.settings.textFieldType)
                ? (_openBlock(), _createBlock("span", _hoisted_11, _toDisplayString(slotProps.option[_ctx.settings.textField || "name"]), 1))
                : _createCommentVNode("", true),
              (_ctx.settings.textField !== false && _ctx.settings.textFieldType && _ctx.settings.textFieldType === 'date')
                ? (_openBlock(), _createBlock("span", _hoisted_12, _toDisplayString(_ctx.getTime(slotProps.option[_ctx.settings.textField || "name"])), 1))
                : _createCommentVNode("", true)
            ]),
            (_ctx.settings.badgeField && slotProps.option[_ctx.settings.badgeField])
              ? (_openBlock(), _createBlock(_component_Badge, {
                  key: 1,
                  value: slotProps.option[_ctx.settings.badgeField],
                  severity: _ctx.settings.badgeSeverity || 'info'
                }, null, 8, ["value", "severity"]))
              : _createCommentVNode("", true),
            (_ctx.settings.badgeIcon && slotProps.option[_ctx.settings.badgeIcon] === true)
              ? (_openBlock(), _createBlock(_component_Badge, {
                  key: 2,
                  severity: _ctx.settings.badgeSeverity || 'info'
                }, {
                  default: _withCtx(() => [
                    _hoisted_13
                  ]),
                  _: 1
                }, 8, ["severity"]))
              : _createCommentVNode("", true),
            _createVNode(_component_KnListButtonRenderer, {
              buttons: _ctx.settings.buttons,
              selectedItem: slotProps.option,
              onClick: ($event: any) => (_ctx.clickedButton($event, slotProps.option))
            }, null, 8, ["buttons", "selectedItem", "onClick"])
          ], 10, ["onClick"])), [
            [_directive_tooltip, slotProps.option[_ctx.settings.tooltipField || 'description']]
          ])
        : _createCommentVNode("", true)
    ]),
    _: 2
  }, [
    (_ctx.settings.sortFields)
      ? {
          name: "header",
          fn: _withCtx(() => [
            (_ctx.settings.fullTextSearch)
              ? (_openBlock(), _createBlock("div", _hoisted_1, [
                  _createVNode("div", _hoisted_2, [
                    _createVNode("input", {
                      type: "text",
                      class: "p-listbox-filter p-inputtext p-component",
                      placeholder: "search",
                      role: "searchbox",
                      value: _ctx.filterValue,
                      onKeyup: _cache[1] || (_cache[1] = ($event: any) => (_ctx.searchFilter($event)))
                    }, null, 40, ["value"]),
                    _hoisted_3
                  ])
                ], 512))
              : _createCommentVNode("", true),
            _withDirectives(_createVNode(_component_Button, {
              icon: "fas fa-sort-amount-down-alt",
              class: "p-button-text p-button-rounded p-button-plain headerButton",
              onClick: _ctx.toggleSort
            }, null, 8, ["onClick"]), [
              [
                _directive_tooltip,
                _ctx.$t('common.sort'),
                void 0,
                { bottom: true }
              ]
            ]),
            _createVNode(_component_Menu, {
              id: "sortMenu",
              ref: "sortMenu",
              model: _ctx.settings.sortFields,
              popup: true
            }, {
              item: _withCtx(({item}) => [
                _createVNode("a", {
                  class: "p-menuitem-link",
                  role: "menuitem",
                  tabindex: "0",
                  onClick: ($event: any) => (_ctx.sort($event, item.name || item))
                }, [
                  (_ctx.selectedDirection === 'asc')
                    ? (_openBlock(), _createBlock("span", {
                        key: 0,
                        class: ["p-menuitem-icon fas", { 'fa-sort-amount-up-alt': _ctx.selectedSort === (item.name || item) }]
                      }, null, 2))
                    : (_openBlock(), _createBlock("span", {
                        key: 1,
                        class: ["p-menuitem-icon fas", { 'fa-sort-amount-down-alt': _ctx.selectedSort === (item.name || item) }]
                      }, null, 2)),
                  _createVNode("span", _hoisted_4, _toDisplayString(_ctx.$t(item.label || item)), 1)
                ], 8, ["onClick"])
              ]),
              _: 1
            }, 8, ["model"])
          ])
        }
      : undefined
  ]), 1032, ["options", "class", "filter", "filterPlaceholder", "filterFields", "emptyFilterMessage"]))
}